module.exports = __webpack_public_path__ + "static/img/zombs.9f2fe6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/hero/zombs.png
// module id = JQjP
// module chunks = 35